import { Component, AfterViewInit, ViewChild, Input,ElementRef, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatTableDataSource } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { merge, Observable, of as observableOf, Subject } from 'rxjs';
import { catchError, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { MessageService } from 'src/app/services/message/message.service';
import { FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { CoreServiceService } from 'src/app/services/core/core-service.service';
import { environment } from 'src/environments/environment';
import { ProfileComponent } from 'src/app/pages/profile/profile.component';


export interface searchFilter {
  transmitter: string;
  recipient: string;
  projectId: string;
  dateBefore: any;
  dateDeadline: any;
  dateDeadlineAfter: any;
  dateAfter: any;
  tag: string;
  copy?: string;
  statut: boolean;
  type: string;
  keyWord: string;
  smartNumber: string,
  isGeneral?: any,
  isThematic?: any,
  isTask?: any
}

@Component({
  selector: 'app-dashboardcontent',
  templateUrl: './dashboardcontent.component.html',
  styleUrls: ['./dashboardcontent.component.scss']
})

export class DashboardcontentComponent implements AfterViewInit, OnDestroy, OnInit {
 
  messages: any = [];
  dataSource: any;
  allMessages: any;
  resultsLength = 0;
  perPage = 30;
  isLoadingResults = false;
  isRateLimitReached = false;
  lastDate = new Date('01/01/4970');
  filterChoosen = null;
  firstLoad = true;

  displayedColumns: string[] = [
    'Date',
    'Projet',
    //'Type',
    'Sous-canal',
    'Expéditeur',
    'Destinataire',
    //'Type',
    'Statut',
    'consult'
  ];
  
  hiddenSearchEngin = true;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('journalWrapper', { static: false }) journalWrapper: ElementRef;

  @Output() EventLaunchSearch = new EventEmitter();
  @Output() EventLaunchSearchDoc = new EventEmitter();
  @Output() EventLaunchFilter = new EventEmitter();
  @Input() ged: boolean = false;
  @Output() projectsLoaded = new EventEmitter<any[]>();
  @Output() transmittersLoaded = new EventEmitter<any[]>();
  @Output() recipientsLoaded = new EventEmitter<any[]>();
  @Output() copiesLoaded = new EventEmitter<any[]>();
  @Output() tagsLoaded = new EventEmitter<any[]>();
  @Output() typesLoaded = new EventEmitter<any[]>();

  // start claude
  currentPage = 1;
  //perPage = 20; // nombre de lignes par page

  // état d'ouverture du menu principal
  showStatutMenu = false;

  // sous-menu actif : 'taches' | 'messages' | null
  activeSubMenu: string | null = null;

  selectedStatus: string = null;

  toggleStatutMenu(): void {
    this.showStatutMenu = !this.showStatutMenu;
    if (!this.showStatutMenu) {
      this.activeSubMenu = null;
    }
  }

  openSubMenu(type: string, event: Event): void {
    event.stopPropagation();
    this.activeSubMenu = this.activeSubMenu === type ? null : type;
  }

  chooseStatus(value: string): void {
    this.selectedStatus = value;
    this.showStatutMenu = false;
    this.activeSubMenu = null;
    // ici tu peux émettre un event vers le parent, appeler un service, etc.
    console.log('Statut choisi :', value);
  }

  // ferme le menu si on clique en dehors
  closeAll(): void {
    console.log("cliqued")
    this.showStatutMenu = false;
    this.activeSubMenu = null;
  }
 
goToPage(page: number) {
  if (page < 1 || page > Math.ceil(this.resultsLength / this.perPage)) return;
  this.currentPage = page;
  this.paginator.pageIndex = page - 1; // MatPaginator est 0-indexé
  this.paginator.page.emit({
    pageIndex: page - 1,
    pageSize: this.perPage,
    length: this.resultsLength
  });
  if(this.journalWrapper && this.journalWrapper.nativeElement) this.journalWrapper.nativeElement.scrollIntoView({block: "start"});
  //document.getElementById('journalWrapper')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

getPageNumbers(): (number | string)[] {
  const total = Math.ceil(this.resultsLength / this.perPage);
  const current = this.currentPage;
  const pages: (number | string)[] = [];

  if (total <= 7) {
    for (let i = 1; i <= total; i++) pages.push(i);
    return pages;
  }

  pages.push(1);
  if (current > 3) pages.push('...');

  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  for (let i = start; i <= end; i++) pages.push(i);

  if (current < total - 2) pages.push('...');
  pages.push(total);

  return pages;
}
 
// --- Avatars ---
// Génère des initiales à partir d'un nom "Prénom NOM"
/*getInitials(fullName: string): string {
  if (!fullName) return '?';
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}*/
 
// Génère une couleur cohérente (déterministe) à partir du nom
getAvatarColor(name: string): string {
  const colors = [
    '#4CAF50', '#2196F3', '#FF9800', '#9C27B0',
    '#00BCD4', '#F44336', '#795548', '#607D8B',
    '#E91E63', '#3F51B5', '#009688', '#FF5722',
  ];
  if (!name) return colors[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
}
 
// Expose Math pour le template
Math = Math;
  // end claude 

  transmitter = null;
  recipient = null;
  projectId = null;
  dateBefore = null;
  dateAfter = null;
  dateDeadline = null;
  dateDeadlineAfter = null;
  tag = null;
  statut = null;
  copy = null;
  type = null;
  typemsg = null;
  typebloc = null;
  keyWord = null;
  smartNumber = null;
  isGeneral = null;
  isThematic = null;
  isTask = null;
  statusMsg = null;
  modeDoc = false;
  //contacts: Array<any> = [];
  contactsExp: Array<any> = [];
  contactsDest: Array<any> = [];
  projectLists: Array<any> = [];
  projectTags: any;
  chosenFilter: searchFilter;
  currentUser = null;
  saveCtc = null;
  saveCtcTransmitter = null;
  saveProject = null;
  saveTheme   = null;
  secteur = "";
  hideNav = Number(localStorage.getItem('hideNav'));
  public transmitterCtrl: FormControl = new FormControl();
  public recipientCtrl: FormControl = new FormControl();
  public projectCtrl: FormControl = new FormControl();
  public themeCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();
  recentProject = null;
  searchstepface = "init";
  searchsenderface = "Éxpéditeur";
  searchrecipientface = "Destinataire";
  searchcopyface = "Membre en Copie";
  searchthemeface = "Objet";
  searchtypeface = "Type de Document";
  searchtypemsgface = "Type d'échanges";
  searchtypebloc = "Type de bloc";
  searchproject = "Dossier";
  searchdateface = "Face";
  searchstatusface = "Statut des faces";
  searchnumface = "Numéro du face";
  searchtypes = [];
  searchtypesblocs = [];
  searchtypesfilter = [
    {id: "pdf", nom: "Pdf", image: "search-pdf"},
    {id: "excel", nom: "Excel", image: "search-excel"},
    {id: "word", nom: "Word", image: "search-word"},
    {id: "presentation", nom: "Présentation", image: "search-presentation"},
    {id: "image", nom: "image", image: "search-image"},
    {id: "video", nom: "Vidéo", image: "search-video"},
    {id: "http", nom: "Lien", image: "search-lien"}
  ]
  isTaskSearch = null;
  isTaskMode = null;
  searchtypesApi = [];
  filterprojectf = "date";
  filtersenderf = "alpha";
  filterrecipientf = "alpha";
  filtertagf = "date";
  searchProjectF = null;
  searchSenderF = null;
  searchRecipientF = null;
  searchCopyF = null;
  searchTagF = null;
  projectInit = [];
  projectSendersInit = [];
  searchRecipientInit = [];
  searchCopyInit = [];
  searchSenderInit = [];
  searchTagInit = [];
  searchTags = [];
  searchresLength = 0;
  targetValue: number = 0;
  intervalId: any;
  private refreshSearchObs = new Subject();
  filterChoosenSearch= null;
  name: string;
  profile: string;
  commonRef: string;
  hoveredOption: 'chat' | 'face' | null = null;

  
  stat_projects = 0;
  stat_documents = 0;
  stat_exchanges = 0;
  stat_tasks = 0;
  //statusanswered = true;
  //statusnotanswered = true;
  vibrantColors = [
    "#e7e0ff", // bleu très clair
    "#caf1ee", // vert très clair
    "#fff0d3", // orange clair
    "#fbd8dc", // rose clair  #fdc1c8
    "#d8fdd2", // violet clair
    "#f4ded1", // turquoise clair   fdc1c8
    "#d1e8ff", // mauve clair
    "#cbf2ef"
  ];

  colorMap: Record<string, string> = {
    '#e7e0ff': '#5d45de', // bleu → violet foncé
    '#caf1ee': '#008476', // vert → vert foncé
    '#fff0d3': '#9d6b2b', // orange → brun
    '#fbd8dc': '#cd0635', // rose → bordeaux
    '#d8fdd2': '#1c8555', // vert → vert foncé
    '#f4ded1': '#855436', // beige → marron
    '#d1e8ff': '#0060d3', // bleu → bleu foncé
    '#cbf2ef': '#008379'  // turquoise → turquoise foncé
  };
  notified = false;
  private destroy$ = new Subject<void>();
  selectedFilter = 'tous';

  getStats(){
    this.authService.getGlobalStats().subscribe(  
    (success) => {
     
      var dataArray = success['hydra:member'];
      this.stat_projects = dataArray.totalProject;
      this.stat_documents = dataArray.totalFile;
      this.stat_exchanges = dataArray.totalMessage;
      this.stat_tasks = dataArray.totalTask;
    },
    (error) => {
      alert('Erreur global stats ! : ' + error)
    });
   }

  filterMessages(type = 'all'){
      this.statusMsg = null;
      this.isTaskMode = null;
      //this.isThematic = null;
      //this.isGeneral = null;
      //this.statut = null;
      //this.dateDeadline = null;

      this.transmitter = null;
      this.recipient = null;
      this.projectId = null;
      this.dateBefore  = null;
      this.dateAfter  = null;
      this.dateDeadline = null;
      this.dateDeadlineAfter = null;
      this.tag = null;
      this.statut = null;
      this.copy = null;
      this.type = null;
      this.keyWord = null;
      this.smartNumber = null;
      this.typebloc = null;
      this.isGeneral = null;
      this.isThematic = null;
      //this.statusMsg = null;
      this.isTaskSearch = null;
      this.isTask = null;
      this.chosenFilter = null;

      /*if(this.chosenFilter) {
        console.log("filter existed")
        this.chosenFilter.isTask = this.isTaskMode;
      } else {*/
        /*console.log("filter not existed")
        this.chosenFilter = { 
          transmitter: this.transmitter,
          recipient: this.recipient,
          projectId: this.projectId,
          dateBefore: this.dateBefore,
          dateAfter: this.dateAfter,
          dateDeadline: this.dateDeadline,
          dateDeadlineAfter: this.dateDeadlineAfter,
          tag: this.tag,
          statut: this.statut, 
          copy: this.copy,
          type: this.type,
          keyWord: (this.keyWord ? this.keyWord.trim() : null),
          smartNumber: this.smartNumber,
          isGeneral: this.isGeneral,
          isThematic: this.isThematic,
          isTask: this.isTaskMode
        };*/
    //}
    this.getAllMessages(this.chosenFilter);
  }

onFilterChange(value: string) {
  this.statusMsg = null;
  this.isTaskMode = null;
  this.isThematic = null;
  this.isGeneral = null;
  this.statut = null;
  this.dateDeadline = null;
  if(value === 'all'){
      this.isTaskMode = null;
    } else if(value === 'message'){
      this.isTaskMode = false;
    } else this.isTaskMode = true;

  if(this.chosenFilter) {
    console.log("filter existed")
    this.chosenFilter.isTask = this.isTaskMode;
  } else {
    console.log("filter not existed")
    this.chosenFilter = { 
        transmitter: this.transmitter,
        recipient: this.recipient,
        projectId: this.projectId,
        dateBefore: this.dateBefore,
        dateAfter: this.dateAfter,
        dateDeadline: this.dateDeadline,
        dateDeadlineAfter: this.dateDeadlineAfter,
        tag: this.tag,
        statut: this.statut, 
        copy: this.copy,
        type: this.type,
        keyWord: (this.keyWord ? this.keyWord.trim() : null),
        smartNumber: this.smartNumber,
        isGeneral: this.isGeneral,
        isThematic: this.isThematic,
        isTask: this.isTaskMode
      };
  }
  this.getAllMessages(this.chosenFilter);
}

  constructor(private location: Location, public dialog: MatDialog, private coreService: CoreServiceService, private authService: AuthService, private router: Router, private route: ActivatedRoute, private messageService: MessageService) { 
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    delete currentUser.token;
    delete currentUser.refresh_token;
    delete currentUser.roles;
    this.currentUser = currentUser;
    this.route.queryParams.subscribe(params => {
      this.recentProject = params['projet'];
    });
  }

  changeBetweenFilGed(number = null){
    if(number == 1 && !this.modeDoc) return;
    if(number == 2 && this.modeDoc) return;
    this.initAttributes();
    if(this.modeDoc == false) {
      console.log("changed from his.modeDoc == false")
      this.launchSearchDocGed();
    } else {
      console.log("changed from his.modeDoc == fals")
      this.modeDoc = false;
      this.EventLaunchSearch.emit(this.chosenFilter);
      //this.launchSearchInstant();
    }
  }

  getSubject(subject){
    if(subject === "Thématique d'échange"){
      return "Thèmatique";
      } else return subject;
  }

  initAttributes(){
    this.transmitter = null;
    this.projectId = null;
    this.dateBefore  = null;
    this.dateAfter  = null;
    this.type = null;
    this.keyWord = null;
    this.smartNumber = null;
  }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(){
    this.authService.setMode('cooperatif');
    this.resultsLength = 0; 
    this.searchresLength = 0;
    this.route.paramMap.subscribe(params => {
      if(params.get('notified')){
        this.notified = true;
        this.selectStatusFace('Non répondues', 'false');
        this.selectSenderFace(this.currentUser.givenName, this.currentUser.familyName, this.currentUser.id);
        this.chosenFilter = { 
          transmitter: this.transmitter,
          recipient: null,
          projectId: null,
          dateBefore: null,
          dateAfter: null,
          dateDeadline: null,
          dateDeadlineAfter: null,
          tag: null,
          statut: this.statut, 
          type: 'QUESTION',
          keyWord: null,
          smartNumber: null,
          isGeneral: false,
          isThematic: false
        };
        this.getAllMessages(this.chosenFilter);
        //this.launchSearch();
      } else this.getAllMessages(null); 
    });
    //this.getStats();
    //this.getAllMessages(this.filterChoosen);
    //this.getAllMessages(null);
    this.secteur = localStorage.getItem('secteur');
  
    this.getContact();
    //this.getReceiver(null);
    this.loadProject(); 
    this.loadTypesBlocs();
    this.loadTypes();

    this.authService.closeBloc.subscribe((term) =>{ 
      if(term == 1){
        this.resetSearch();
      }
      //console.log('dans le smarnumber idmessage ==> '+idMessage);
    });
    this.authService.obprojectChosen.subscribe((idMessage) =>{ 
      this.smartNumber = idMessage;
      //console.log('dans le smarnumber idmessage ==> '+idMessage);
    });

    this.authService.changeModeProject
    .pipe(takeUntil(this.destroy$))
    .subscribe(res => {
      if (res === 'change') {
        this.redirectToHistoInstant();
      }
    });

    this.coreService.toggleSidebar.subscribe((res) => {
      this.hideNav = Number(res);
    });

    this.ged = false;
    this.hiddenSearchEngin = true;

  }

  getStatutTerminated(element: any){
    const today = new Date();
    if (element.isMessageDisabled) {
      return "desabled";
    }

    /*if((element.senderId === this.currentUser.id || this.isReadComment(element)) && (element.isThematic || element.isGeneral)){
      return "read";
    }*/

    if(element.isThematic && element.isGeneral){
      return "team";
    }

    if(!element.isThematic && element.isGeneral){
      return "project";
    }

    if (!element.read) {
      return "notterminated";
    }

    return "terminated";
  }

  /*getStatutTerminated(element: any): { isTerminated: boolean } {
    const today = new Date();

    if (!element.read) {
      return { isTerminated: false };
    }

    return { isTerminated: true };
  }*/

  getTotalMessage(date : any){
    const target = new Date(date).toDateString();
    return this.dataSource.filter(m => new Date(m.date).toDateString() === target).length;
  }

  getStatut(element: any): { isDepasse: boolean, nbJours?: number } {
    const today = new Date();

    if (!element.deadline) {
      return { isDepasse: false };
    }

    const deadlineDate = new Date(element.deadline);

    if (deadlineDate > today) {
      return { isDepasse: false };
    }

    const diffTime = today.getTime() - deadlineDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));

    return { isDepasse: true, nbJours: diffDays };
  }

  

  getRestDays(element: any): { isDepasse: boolean, nbJours?: number } {
    const today = new Date();

    if (!element.deadline) {
      return { isDepasse: false };
    }

    const deadlineDate = new Date(element.deadline);

    const diffTime = deadlineDate.getTime() - today.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));

    return { isDepasse: false, nbJours: diffDays };
  }

  getStatutResponse(element: any): { isDepasse: boolean, nbJours?: number } {

    const deadlineDate = new Date(element.deadline);
    const responseDate = new Date(element.answer.dateCreated);

    if (deadlineDate > responseDate) {
      return { isDepasse: false };
    }

    const diffTime = responseDate.getTime() - deadlineDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));

    return { isDepasse: true, nbJours: diffDays };
  }

  calculateDate(date) {
    var result = 0;
    var today = new Date().setHours(0, 0, 0, 0);
    var yesterday = new Date(new Date().setDate(new Date().getDate()-1)).setHours(0, 0, 0, 0);
    date = new Date(date);
    if (date >= today) {
      result = 1;
    } else if (date >= yesterday) {
      result = 2;
    } else result = 3;
    return result;
  }

  initFilterProject(element){
    this.EventLaunchFilter.emit('all');
    
  }

  redirectToHistoInstant(){
    this.router.navigate(['/dashboardinst']);
  }

  ngAfterViewInit() {  

    this.recipientCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterRecipient();
      });

    this.transmitterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterTransmitter();
    });


    this.projectCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterProject();
      });

    this.themeCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.themeProject();
      });
   

  }



 loadFilterElement(){
    //console.log("on loadFilterElement");
    if (this.firstLoad == true) {
      this.getContact();
      this.loadProject();
      this.loadTypes();
    }
    this.firstLoad = false;
  }

  fcthiddenSearchEngin(){
      this.searchstepface = "init";
    if (this.hiddenSearchEngin == false){
      this.hiddenSearchEngin = true;
    } else
      this.hiddenSearchEngin = false;
  }

  protected filterRecipient() {
    if(this.saveCtc == null){
      this.saveCtc = this.contactsDest;
    }

    let search = this.recipientCtrl.value;
    if (!search) {
      this.contactsDest = this.saveCtc;
      return;
    } else {
      search = search.toLowerCase();
      this.contactsDest = this.saveCtc.filter(bank => bank.givenName.toLowerCase().indexOf(search) > -1 || bank.familyName.toLowerCase().indexOf(search) > -1 );
    }
  }

  protected filterTransmitter(){
    if(this.saveCtcTransmitter == null){
      this.saveCtcTransmitter = this.contactsExp;
    }

    let search = this.transmitterCtrl.value;
    if (!search) {
      this.contactsExp = this.saveCtcTransmitter;
      return;
    } else {
      search = search.toLowerCase();
      this.contactsExp = this.saveCtcTransmitter.filter(bank => bank.givenName.toLowerCase().indexOf(search) > -1 || bank.familyName.toLowerCase().indexOf(search) > -1 );
    }
  }

  protected filterProject() {
    if(this.saveProject == null){
      this.saveProject = this.projectLists;
    }

    let search = this.projectCtrl.value;
    if (!search) {
      this.projectLists = this.saveProject;
      return;
    } else {
      search = search.toLowerCase();
      this.projectLists = this.saveProject.filter(bank => bank.libelle.toLowerCase().indexOf(search) > -1);
    }
  }

  protected themeProject() {
    // console.log("calling themeProject");
    if(this.saveTheme == null){
      this.saveTheme = this.projectTags;
      // console.log("in themeProject", this.saveTheme);
    }else{
      // console.log("else themeProject", this.projectTags);
    }

    let search = this.themeCtrl.value;
    if (!search) {
      this.projectTags = this.saveTheme;
      return;
    } else {
      search = search.toLowerCase();
      this.projectTags = this.saveTheme.filter(bank => bank.libelle.toLowerCase().indexOf(search) > -1);
    }
  }

  onSearchProjectF() {
    if (this.searchProjectF.trim() === '' || this.searchProjectF == null) {
      this.searchProjectF = null;
      this.projectInit = this.projectLists;
      this.filterProjectF(this.filterprojectf);
    } else {
      var search = this.searchProjectF.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.projectInit = this.projectLists.filter(bank => bank.libelle.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1);
    }
  }

  onSearchSenderF() {
    if (this.searchSenderF.trim() === '' || this.searchSenderF == null) {
      this.searchSenderF = null;
      this.searchSenderInit = this.contactsExp;
      this.filterSendersF(this.filtersenderf);
    } else {
      var search = this.searchSenderF.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.searchSenderInit = this.contactsExp.filter(bank => bank.fullName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  onSearchRecipientF() {
    if (this.searchRecipientF.trim() === '' || this.searchRecipientF == null) {
      this.searchRecipientF = null;
      this.searchRecipientInit = this.contactsDest;
      this.filterRecipientF(this.filterrecipientf);
    } else {
      var search = this.searchRecipientF.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.searchRecipientInit = this.contactsDest.filter(bank => bank.fullName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  onSearchTagF() {
    if (this.searchTagF.trim() === '' || this.searchTagF == null) {
      this.searchTagF = null;
      this.searchTagInit = this.searchTags;
      this.filterTagF(this.filtertagf);
    } else {
      var search = this.searchTagF.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.searchTagInit = this.searchTags.filter(bank => bank.libelle.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1);
    }
  }

  //************* */
  filterProjectF(val : any){
    this.filterprojectf = val;
    if(val == "date"){
        this.projectInit.sort((a, b) => {
          if ( a.dateCreated > b.dateCreated ){
            return -1;
          }
          if ( a.dateCreated < b.dateCreated ){
            return 1;
          }
          return 0;
        })
          /*if ( a.lastface > b.lastface ){
            return -1;
          }
          if ( a.lastface < b.lastface ){
            return 1;
          }
          return 0;*/
    } else {
      this.projectInit.sort((a, b) => {
        if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
          return -1;
        }
        if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }

  getRandomColor(): string {
    const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
    return this.vibrantColors[randomIndex];
  }

  darkenColor(bgColor: string) {
    if (!bgColor) return '#444';
    const key = bgColor.toLowerCase().substring(0, 7);
    return this.colorMap[key] || '#444'
  }

  getInitials(libelle: string): string {
    const words = libelle.split(' ');
    const getFirstChar = (word: string): string => {
      return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
    };
    const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point

    return initials;
  }

  filterSendersF(val : any){
    this.filtersenderf = val;
    if(val == "date"){
        this.searchSenderInit.sort((a, b) => {
          if ( a.createdAt > b.createdAt ){
            return -1;
          }
          if ( a.createdAt < b.createdAt ){
            return 1;
          }
          return 0;
        })
    } else {
      this.searchSenderInit.sort((a, b) => {
        if ( a.fullName.toLowerCase() < b.fullName.toLowerCase() ){
          return -1;
        }
        if ( a.fullName.toLowerCase() > b.fullName.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }

  filterRecipientF(val : any){
    this.filterrecipientf = val;
    if(val == "date"){
        this.searchRecipientInit.sort((a, b) => {
          if ( a.createdAt > b.createdAt ){
            return -1;
          }
          if ( a.createdAt < b.createdAt ){
            return 1;
          }
          return 0;
        })
    } else {
      this.searchRecipientInit.sort((a, b) => {
        if ( a.fullName.toLowerCase() < b.fullName.toLowerCase() ){
          return -1;
        }
        if ( a.fullName.toLowerCase() > b.fullName.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }

  filterTagF(val : any){
    this.filtertagf = val;
    if(val == "date"){
        this.searchTagInit.sort((a, b) => {
          if ( a.createdAt > b.createdAt ){
            return -1;
          }
          if ( a.createdAt < b.createdAt ){
            return 1;
          }
          return 0;
        })
    } else {
      this.searchTagInit.sort((a, b) => {
        if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
          return -1;
        }
        if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }
  

  dataMap(data: any, first = null) {

    var strId = data['project']['@id']; 
    var splittedID = strId.split("/"); 
    var idProject = splittedID[splittedID.length-1];  
    var listTag : any[] = data['tags'];
    var date = data['dateCreated'];
    var answerDate = data['motionAt']; 
    var isNewDay = this.isNewDay(date);
    var smartNumber = data['smartNumber'];

    var typeMessage = 'QUESTION';

    if (data['type'] == 'QUESTION') {
      typeMessage = 'Question';
    }
    else if (data['type'] == 'COMMENT'){
      typeMessage = 'Commentaire';
      smartNumber = data['number'];
    }
    else if (data['type'] == 'ANSWER'){
      typeMessage = 'Réponse';
    }

    const message: any = {
      'id': idProject,
      'project': data['project'],
      'first': first,
      'tag': (listTag[0] ? listTag[0].libelle  : '' ),
      'date': date,
      "answerDate": answerDate,
      'typeParse': typeMessage,
      'type': data['type'],
      'private': data['isPrivate'],
      'isGeneral': data['isGeneral'],
      'isThematic': data['isThematic'],
      'isTask': data['isTask'],
      'sender': (data['author'] ? data['author'] : ''),
      'senderId': (data['author'] ? data['author']['id'] : ''),
      'recipient': (data['recipient'] ? data['recipient'] : ''),
      'copy': (data['copy'] ? data['copy'].length : ''),
      'copyusers': (data['copy'] ? data['copy'] : []),
      'read': data['isMessageAnswered'],
      'deadline': data['deadline'],
      'number': data['number'],
      'smartNumber': smartNumber,
      'parentItem': data['parentItem'],
      'answer': data['answer'],
      'filegeneric': data['filegeneric'],
      'isMessageDisabled': data['isMessageDisabled'],
      'isMessageAnswered': data['isMessageAnswered'],
      'isNewDay' : isNewDay,
      'color' : this.getDeadlineColor(data)
    };

    return message;
  }
  
  

  getDeadlineColor(element: any){

    if(element.type === 'QUESTION' && !element.isTask && !element.isThematic && !element.isGeneral) {
      if(element.isMessageAnswered) return '#57b031';
      else return '#e53935';
    } else if(element.type === 'QUESTION' && element.isTask && !element.isThematic && !element.isGeneral){
      if(element.isMessageAnswered) return '#57b031';
      else if(!element.isMessageAnswered && !this.getStatut(element).isDepasse && !element.isMessageDisabled) return '#5e93bf';
      else if(!element.isMessageAnswered && this.getStatut(element).isDepasse && !element.isMessageDisabled) return '#e53935';
      else if(element.isMessageDisabled) return '#888';
      else return '#333';
    }
  }

  getMessagesColor(){

    switch (this.statusMsg) {
      case 'Répondus':
        return '#58af31';

      case 'Non répondus':
        return '#e53935';
      
      case 'Annulés':
        return '#888';

      default:
        return '#000';
    }
  }

  getTasksColor(){

    switch (this.statusMsg) {

      case 'Échéance non dépassée':
        return '#5e93bf';

      case 'Échéance dépassée':
        return '#e53935';

      case 'Terminées':
        return '#58af31';

      case 'Annulées':
        return '#888';

      default:
        return '#000';
    }
  }

  getstatusColor(){

    switch (this.statusMsg) {
      case 'Répondu':
        return '#58af31';

      case 'Non répondu':
        return '#e53935';

      case 'Échéance non dépassée':
        return '#5e93bf';

      case 'Échéance dépassée':
        return '#e53935';

      case 'Terminée':
        return '#58af31';

      case 'Annulée':
        return '#888';
      
      case 'Annulé':
        return '#888';

      default:
        return '#000';
    }
  }

  isReadComment(element){
    if(!element || !element.copyusers || element.copyusers.length == 0) return false;
    for (var i = 0; i < element.copyusers.length; i++) {
      if((element.copyusers[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.copyusers[i].isRead == true)){
        return true;
      }
    }
    return false;
  }

 public getAllMessages(searchChoose) {
  if(searchChoose) console.log("istask "+searchChoose.isTask)
    this.paginator.pageIndex = 0;
    this.filterChoosen = searchChoose;

    merge(this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.authService.getAllMessages(this.paginator.pageIndex, this.perPage, this.filterChoosen);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;    

          this.resultsLength = data['hydra:totalItems']; 
          this.searchresLength = 0;

          return data['hydra:member'];
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => { 
        //console.log({test1111:data})
        //console.log('contenu de data '+ JSON.stringify(data));
        this.messages = [];
        this.lastDate = new Date('01/01/4970');
        data=data.filter(item=>!item.action)
        //console.log({journalComm:data})
        var j = 0;
        var first = false;
        data.forEach(element => {
          j++;
          if(j == 1) first = true;
          this.messages.push(this.dataMap(element, first));
          first = false;
        });

        let afterIsNewDay = false;
        this.messages.reverse().forEach((element, index) => {
          if(afterIsNewDay || index == 0){
            this.messages[index]["afterIsNewDay"] = true;
            afterIsNewDay = false;
            //console.log("afterIsNewDay")
          }
          if(element.isNewDay == true){
            afterIsNewDay = true;
          }
        });

        this.dataSource = this.messages.reverse(); 
        this.allMessages = this.dataSource;
         

      });

      merge(this.refreshSearchObs)
      .pipe(
        startWith({}),
        switchMap(() => {
          return this.authService.getAllMessages(this.paginator.pageIndex, this.perPage, this.filterChoosenSearch);
        }),
        map(data => {
          this.targetValue = data['hydra:totalItems'];
        }),
        catchError(() => {    
          return observableOf([]);
        })
      ).subscribe(data => {    
        if(this.checkSearchInit()) this.animateToValue(this.resultsLength);
        else this.animateToValue(this.targetValue);

      });

  }

  isRoundFirst(afterIsNewDay, isNewDay){
    if(afterIsNewDay && isNewDay){
      return "divcontaine afterIsNewDayBL afterIsNewDayTL";
    }else if(afterIsNewDay){
      return "divcontaine afterIsNewDayBL";
    }else if(isNewDay){
      return "divcontaine afterIsNewDayTL";
    }
    return "divcontaine";
  }

  isRoundLast(afterIsNewDay, isNewDay){
    if(afterIsNewDay && isNewDay){
      return "divcontaine afterIsNewDayBR afterIsNewDayTR";
    }else if(afterIsNewDay){
      return "divcontaine afterIsNewDayBR";
    }else if(isNewDay){
      return "divcontaine afterIsNewDayTR";
    }
    return "divcontaine";
  }

  isNewDay(messageDate){
    let currentDate = new Date(messageDate.substring(0,10)); 
    //console.log('this.lastDate ==> '+this.lastDate);
    //console.log('currentDate ==> '+currentDate);
    if(currentDate < this.lastDate)
    {
      // console.log('Une section ==> '+ currentDate);
      this.lastDate = currentDate;
      return true;
    } 
    else
    { 
      this.lastDate = currentDate; 
      return false;
    }
  }

  getReceiver(recipientid){
    if(this.projectId){
      this.authService.getContactsRecipID(this.projectId, this.tag, this.transmitter).subscribe(res => {
        var tmpArrayUser = res['hydra:member'];
        this.contactsDest = [];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].id){
            this.contactsDest.push(tmpArrayUser[i]);
          }
        }
        this.contactsDest.sort(this.compare);
        this.searchRecipientInit = this.contactsDest;
        this.recipientsLoaded.emit(this.searchRecipientInit);
      }, (error) => {
         //console.log(' getTheProject subscribe error '+error.statusText);
      });
    } else {
      this.authService.getAllRecipientsBySender(recipientid).subscribe(res => {
        var tmpArrayUser = res['hydra:member'];
        this.contactsDest = [];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].id){
            this.contactsDest.push(tmpArrayUser[i]);
          }
        }
        this.contactsDest.sort(this.compare);
        this.searchRecipientInit = this.contactsDest;
      }, (error) => {
        //console.log(' getTheProject subscribe error '+error.statusText);
      });
    }
  }

  getContact(recip = false){
    //this.loadContact();

    this.authService.getContactsExpID(this.projectId, this.tag, this.isThematic, this.isGeneral).subscribe(res => {
      this.contactsExp = [];
      var tmpArrayUser = res['hydra:member'];
      for (var i = 0; i < tmpArrayUser.length; i++) {
        this.contactsExp.push(tmpArrayUser[i]);
      }
      this.contactsExp.sort(this.compare);
      this.contactsExp.forEach(element => {
        const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
        element.color = this.vibrantColors[randomIndex];
      });
      this.searchSenderInit = this.contactsExp;
      this.transmittersLoaded.emit(this.searchSenderInit);
    }, (error) => {
         //console.log(' getTheProject subscribe error '+error.statusText);
    });
    if(recip == false){
      this.authService.getContactsRecip().subscribe(res => {
        this.contactsDest = [];
        var tmpArrayUser = res['hydra:member'];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          this.contactsDest.push(tmpArrayUser[i]);
        }
        this.contactsDest.sort(this.compare);
        this.contactsDest.forEach(element => {
          const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
          element.color = this.vibrantColors[randomIndex];
        });
        this.searchRecipientInit = this.contactsDest;
      }, (error) => {
          //console.log(' getTheProject subscribe error '+error.statusText);
      });
    }

  }

  /*loadContact(url?: string){
    url = url ? url : undefined;
    this.authService.getContacts(url).subscribe(res => {
      this.contacts = this.contacts.concat(res['hydra:member']);
      
      if(this.contacts.length && this.contacts[0].id != this.currentUser.id){
        this.contacts.unshift(this.currentUser);
      }
      this.contacts.sort(this.compare);

      if(res['hydra:view']['hydra:next']){
        this.loadContact(res['hydra:view']['hydra:next'].replace("/api", ""));
      }
    }); 
  }*/

  compare( a, b ) {
    if ( a.givenName.toLowerCase() < b.givenName.toLowerCase() ){
      return -1;
    }
    if ( a.givenName.toLowerCase() > b.givenName.toLowerCase() ){
      return 1;
    }
    return 0;
  }

  loadTypes(url?: string){
    this.searchtypesApi = [];
    this.authService.getMessageTypes(this.projectId, this.transmitter, this.recipient, null, this.tag).subscribe(res => {
      this.searchtypesApi = this.searchtypesApi.concat(res['hydra:member']);
      this.searchtypes = this.searchtypesfilter.filter(item => this.searchtypesApi.includes(item.id));
      this.typesLoaded.emit(this.searchtypes);
    }); 
  }

  loadTypesBlocs(url?: string){
    this.searchtypesblocs = [];
    this.authService.getMessageBlocTypes(this.projectId, this.transmitter, this.recipient, null, this.tag).subscribe(res => {
      var result = this.searchtypesApi.concat(res['hydra:member']);
      const order = { 'face': 0, 'team': 1, 'general': 2 };
      result.sort((a, b) => order[a] - order[b]);
      this.searchtypesblocs = result;
    }); 
  }

  loadProject(url?: string){
    url = url ? url : undefined;
    this.projectLists = [];
     this.projectInit = [];
    this.authService.getProjectsMessages().subscribe(res => {
      this.projectLists = this.projectLists.concat(res['hydra:member']);
      /*
      this.projectLists = this.projectLists.sort(function (a, b) {
          if (a.libelle.toLowerCase() < b.libelle.toLowerCase()) { return -1; }
          if (a.libelle.toLowerCase() > b.libelle.toLowerCase()) { return 1; }
          return 0;
      })
      if(res['hydra:view']['hydra:next']){
        this.loadProject(res['hydra:view']['hydra:next'].replace("/api", ""));
      }*/
      this.projectInit = this.projectLists;
      this.projectInit.sort((a, b) => {
          if ( a.dateCreated > b.dateCreated ){
            return -1;
          }
          if ( a.dateCreated < b.dateCreated ){
            return 1;
          }
          return 0;
      })
      console.log("long : "+this.projectInit.length)
      this.projectsLoaded.emit(this.projectInit);
      this.projectInit.forEach(project => {
        project.randomColor = this.getRandomColor();
      });
    }); 
  }

  getSujet(idProject){
    this.projectId = idProject;
    this.searchTags = [];
    this.authService.getTagsByProject(idProject, this.isThematic, this.isGeneral).subscribe(res => {
      this.searchTags = this.searchTags.concat(res['hydra:member']);
      this.searchTags.sort((a, b) => {
          if ( a.createdAt > b.createdAt ){
            return -1;
          }
          if ( a.createdAt < b.createdAt ){
            return 1;
          }
          return 0;
      })
      this.searchTagInit = this.searchTags;
      this.tagsLoaded.emit(this.searchTagInit);
    }, (error) => {
       //console.log(' getTheProject subscribe error '+error.statusText);
    });
  }


  search(){
    if(this.modeDoc){
      this.launchSearchDoc()
    }else{
      this.launchSearch()
    }
  }

  filterStatusMessages(libelle = 'status', answered = null, isTaskMode = null){
    this.isTaskMode = isTaskMode;
    this.statusMsg = libelle;
    this.statut = null;
    this.dateDeadline = null;
    this.dateDeadlineAfter = null;
    this.isThematic = null;
    this.isGeneral = null;
    if(answered == null){
      this.isThematic = false;
      this.isGeneral = false;
      this.statut = null;
    }
    if(answered == 'answered' || answered == 'finished') this.statut = true;
    else if(answered == 'notanswered') {
      this.statut = false;
      this.isThematic = false;
      this.isGeneral = false;
    } else if(answered == 'inprogress') {
      this.statut = false;
      this.isThematic = false;
      this.isGeneral = false;
      this.dateDeadlineAfter = new Date();
    } else if(answered == 'cancelled' || answered == 'archived') {
      this.statut = 'archived';
      this.isThematic = false;
      this.isGeneral = false;
    } else if (answered == 'depassed'){
      this.dateDeadline = new Date();
      this.statut = false;
    }
    this.showStatutMenu = false;
    this.activeSubMenu = null;
    this.launchSearch(null, true);
  }
  
  launchSearch(ged = null, filtre = null){
    this.modeDoc = false;
    this.isTask = null;
    var task = this.isTaskSearch;
    if(filtre) task = this.isTaskMode;
    //if(!ged) this.hiddenSearchEngin = true;
    if((this.dateDeadline != null || this.dateDeadlineAfter != null) && (this.statut == null)){
      /*
      alert("statut "+this.statut)
      this.statut = false;
      this.chosenFilter.statut = false;*/
      this.chosenFilter = { 
        transmitter: this.transmitter,
        recipient: this.recipient,
        projectId: this.projectId,
        dateBefore: this.dateBefore,
        dateAfter: this.dateAfter,
        dateDeadline: this.dateDeadline,
        dateDeadlineAfter: this.dateDeadlineAfter,
        tag: this.tag,
        statut: false, 
        copy: this.copy,
        type: this.type,
        keyWord: (this.keyWord ? this.keyWord.trim() : null),
        smartNumber: this.smartNumber,
        isGeneral: this.isGeneral,
        isThematic: this.isThematic,
        isTask: task
      };
    } else {
      this.chosenFilter = { 
        transmitter: this.transmitter,
        recipient: this.recipient,
        projectId: this.projectId,
        dateBefore: this.dateBefore,
        dateAfter: this.dateAfter,
        dateDeadline: this.dateDeadline,
        dateDeadlineAfter: this.dateDeadlineAfter,
        tag: this.tag,
        statut: this.statut, 
        copy: this.copy,
        type: this.type,
        keyWord: (this.keyWord ? this.keyWord.trim() : null),
        smartNumber: this.smartNumber,
        isGeneral: this.isGeneral,
        isThematic: this.isThematic,
        isTask: task
      };
    }
    //alert("this "+this.statut)
    /*
    this.chosenFilter = { 
      transmitter: this.transmitter,
      recipient: this.recipient,
      projectId: this.projectId,
      dateBefore: this.dateBefore,
      dateAfter: this.dateAfter,
      dateDeadline: this.dateDeadline,
      dateDeadlineAfter: this.dateDeadlineAfter,
      tag: this.tag,
      statut: this.statut, 
      type: this.type,
      keyWord: (this.keyWord ? this.keyWord.trim() : null),
      smartNumber: this.smartNumber
    };*/
    
    //this.getAllMessages(this.chosenFilter)
    //console.log(' launchSearch '+ JSON.stringify(this.chosenFilter) );
    //this.fcthiddenSearchEngin();
    this.EventLaunchSearch.emit(this.chosenFilter);

  }

  filterMessageCount(ged = null){

    //this.modeDoc = false;
    //if(!ged) this.hiddenSearchEngin = true;
    if((this.dateDeadline != null || this.dateDeadlineAfter != null) && (this.statut == null)){
      /*
      alert("statut "+this.statut)
      this.statut = false;
      this.chosenFilter.statut = false;*/
      this.filterChoosenSearch = { 
        transmitter: this.transmitter,
        recipient: this.recipient,
        projectId: this.projectId,
        dateBefore: this.dateBefore,
        dateAfter: this.dateAfter,
        dateDeadline: this.dateDeadline,
        dateDeadlineAfter: this.dateDeadlineAfter,
        tag: this.tag,
        statut: false,
        copy: this.copy, 
        type: this.type,
        keyWord: (this.keyWord ? this.keyWord.trim() : null),
        smartNumber: this.smartNumber,
        isGeneral: this.isGeneral,
        isThematic: this.isThematic,
        isTask: this.isTask
      };
    } else {
      this.filterChoosenSearch = { 
        transmitter: this.transmitter,
        recipient: this.recipient,
        projectId: this.projectId,
        dateBefore: this.dateBefore,
        dateAfter: this.dateAfter,
        dateDeadline: this.dateDeadline,
        dateDeadlineAfter: this.dateDeadlineAfter,
        tag: this.tag,
        statut: this.statut, 
        copy: this.copy, 
        type: this.type,
        keyWord: (this.keyWord ? this.keyWord.trim() : null),
        smartNumber: this.smartNumber,
        isGeneral: this.isGeneral,
        isThematic: this.isThematic,
        isTask: this.isTask
      };
    }
    this.refreshSearchObs.next();

  }

  animateToValue(newValue: number) {
    if (newValue == this.searchresLength) return;
  
    const step = newValue > this.searchresLength ? 1 : -1;
  
    // Durée totale de l'animation (ici 1 seconde, à ajuster si nécessaire)
    const animationDuration = 1000; // 1000 ms = 1 seconde
    const totalSteps = Math.abs(newValue - this.searchresLength); // nombre d'incréments nécessaires
    const stepDuration = animationDuration / totalSteps; // durée de chaque incrément
  
    let startTime = performance.now(); // Horodatage au début de l'animation
    let lastStepTime = startTime; // Temps du dernier "step" effectué
    let currentStep = 0; // Compteur des étapes réalisées
  
    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime; // Temps écoulé depuis le début de l'animation
      const progress = Math.min(elapsed / animationDuration, 1); // Calcul du progrès de l'animation
  
      // Nombre d'étapes réalisées jusqu'à maintenant, basé sur le temps écoulé
      currentStep = Math.floor(progress * totalSteps);
  
      // Si une nouvelle étape doit être effectuée
      if (currentTime - lastStepTime >= stepDuration) {
        this.searchresLength = this.searchresLength + step;
        lastStepTime = currentTime; // Mettre à jour le temps du dernier step
  
        // Si la cible est atteinte, on s'assure que la valeur finale est atteinte
        if ((step === 1 && this.searchresLength >= newValue) || (step === -1 && this.searchresLength <= newValue)) {
          this.searchresLength = newValue;
        }
      }
  
      // Si l'animation n'est pas encore terminée, on continue l'animation
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // À la fin de l'animation, on s'assure que la valeur finale est bien celle attendue
        this.searchresLength = newValue;
      }
    };
  
    // Démarre l'animation
    requestAnimationFrame(animate);
  }

  openProfilDialog() {
    this.dialog.closeAll();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'contactpanel';
    dialogConfig.id = 'balchal718';
    dialogConfig.width = '550px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = { name: this.name, profile: this.profile, commonRef: this.commonRef };
    //const dialogRef = this.dialog.open(ProfileComponent, dialogConfig);
    const dialogRef = this.dialog.open(ProfileComponent, {
      data: { name: this.name, profile: this.profile, commonRef: this.commonRef },
      panelClass: 'transferclass',
      backdropClass: 'custom-backdrop'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
    });

  }

  launchSearchDoc(){
    if(this.type=="http") {
      alert("Vous ne pouvez pas sélectionner le type lien pour rechercher un document");
      return;
    }
    this.modeDoc = true;

    this.chosenFilter = { 
      transmitter: this.transmitter,
      recipient: this.recipient,
      projectId: this.projectId,
      dateBefore: this.dateBefore,
      dateDeadline: this.dateDeadline,
      dateDeadlineAfter: this.dateDeadlineAfter,
      dateAfter: this.dateAfter,
      tag: this.tag,
      statut: this.statut,
      type: this.type, 
      keyWord: (this.keyWord ? this.keyWord.trim() : null),
      smartNumber: this.smartNumber
    };
    this.fcthiddenSearchEngin();
    this.EventLaunchSearchDoc.emit(this.chosenFilter);

  }

  launchSearchDocGed(){
    if(this.type=="http") {
      alert("Vous ne pouvez pas sélectionner le type lien pour rechercher un document");
      return;
    }
    this.modeDoc = true;

    this.chosenFilter = { 
      transmitter: this.transmitter,
      recipient: this.recipient,
      projectId: this.projectId,
      dateBefore: this.dateBefore,
      dateDeadline: this.dateDeadline,
      dateDeadlineAfter: this.dateDeadlineAfter,
      dateAfter: this.dateAfter,
      tag: this.tag,
      statut: this.statut,
      type: this.type, 
      keyWord: (this.keyWord ? this.keyWord.trim() : null),
      smartNumber: this.smartNumber
    };
    this.searchstepface = "init";
    this.hiddenSearchEngin = true;
    this.EventLaunchSearchDoc.emit(this.chosenFilter);

  }

  checkSearchInit(){
    if(this.projectId == null && this.transmitter == null && this.recipient == null && this.dateBefore  == null && this.dateAfter  == null && this.dateDeadline == null && this.dateDeadlineAfter == null && this.tag == null && this.statut == null && this.type == null && this.keyWord == null && this.smartNumber == null && this.isGeneral == null && this.isThematic == null){
      return true;
    } else {
      return false;
    }
  }

  public resetSearch(){

    this.transmitter = null;
    this.recipient = null;
    this.projectId = null;
    this.dateBefore  = null;
    this.dateAfter  = null;
    this.dateDeadline = null;
    this.dateDeadlineAfter = null;
    this.tag = null;
    this.statut = null;
    this.copy = null;
    this.type = null;
    this.keyWord = null;
    this.smartNumber = null;
    this.typebloc = null;
    this.isGeneral = null;
    this.isThematic = null;
    this.statusMsg = null;
    this.isTaskSearch = null;
    this.isTask = null;
    this.launchSearch("1");
    this.resetSearchFace();

    /*
    if(this.modeDoc == false) 
    {
      this.launchSearch();
    }
    else
    {
      this.launchSearchDoc();
    }*/
    this.getContact();
    //this.getMessageStatus();

  }

  getMessageStatus(){
    
  }
  
  initProjectFace(item = null){
    this.searchproject = "Dossier";
    this.projectId = null; 
    //this.initRecipientFace('1');
    //this.getReceiver(null);
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
    this.initTagFace('1');
    this.initSenderFace('1');
    this.getContact();
    this.initRecipientFace('1');
    this.getReceiver(null);
    //this.initStatusFace('1');
    this.initTypeFace('1');
    this.initTypeBloc('1');
    this.loadTypes();
    //this.getMessageStatus();
  }
  
  initSenderFace(item = null){
    this.searchsenderface = "Expéditeur";
    this.transmitter = null; 
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
    this.initRecipientFace('1');
    this.getReceiver(null);
    //this.initStatusFace('1');
    this.initTypeFace('1');
    this.loadTypes();
    //this.getMessageStatus();
  }

  initRecipientFace(item = null){
    this.searchrecipientface = "Destinataire";
    this.recipient = null;
    //this.getMessageStatus();
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
    //this.initStatusFace('1');
    this.initTypeFace('1');
    this.loadTypes();
    //this.getMessageStatus();
  }

  initTypeFace(item = null){
    this.searchtypeface = "Type de Document";
    this.type = null;
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
  }

  initTypeMsgFace(item = null){
    this.searchtypemsgface = "Type d'échanges";
    this.typemsg = null;
    //if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
    //this.initStatusFace('1');
  }

  initTypeBloc(item = null){
    this.searchtypebloc = "Type de bloc";
    this.typebloc = null;
    this.isGeneral = null;
    this.isThematic = null;
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
  }

  initTagFace(item = null){
    this.searchthemeface = "Objet";
    this.tag = null;
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
    this.initSenderFace('1');
    this.getContact(true);
    this.initRecipientFace('1');
    this.getReceiver(null);
    //this.initStatusFace('1');
    this.initTypeFace('1');
    this.loadTypes();
    //this.getMessageStatus();
  }

  initStatusFace(item = null){
    this.searchstatusface = "Statut des faces";
    this.statut = null;
    this.initProjectFace('1');
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
  }

  selectChoiceFace(item = "init"){
    if(this.searchstepface == "init" && item == "init") {
      this.fcthiddenSearchEngin();
    } else this.searchstepface = item;
  }

  selectProject(libelle, id){
    this.searchproject = libelle;
    this.filtersenderf = 'alpha';
    this.filterrecipientf = 'alpha';
    this.projectId = id;
    this.loadFilterElement();
    this.getSujet(id);
    this.selectChoiceFace("init");
    this.filterMessageCount();
    this.getContact(true);
    this.getReceiver(null);
    //this.getMessageStatus();
  }

  selectSenderFace(givenname, familyname, id){
    this.searchsenderface = givenname + familyname;
    this.transmitter = id;
    this.filtersenderf = 'alpha';
    this.filterrecipientf = 'alpha';
    this.selectChoiceFace("init");
    this.filterMessageCount();
    this.getReceiver(id);
    //this.getMessageStatus();
  }

  selectRecipientFace(givenname, familyname, id){
    this.searchrecipientface = givenname + familyname;
    this.recipient = id;
    this.selectChoiceFace("init");
    this.filterMessageCount();
    //this.getMessageStatus();
  }

  /*
  selectCopyFace(givenname, familyname, id){
    this.searchcopyface = givenname + familyname;
    this.copy = id;
    this.selectChoiceFace("init");
  }*/

  selectTypeFace(libelle, id){
    this.searchtypeface = libelle;
    this.selectChoiceFace("init");
    this.type = id;
    this.filterMessageCount();
  }

  selectTypeMsgFace(type = null){
    if(type == null) this.searchtypemsgface = 'Type d\'échange';
    else if(type == true) this.searchtypemsgface = 'Tâche';
    else this.searchtypemsgface = 'Message';
    this.isTaskSearch = type;
    this.selectChoiceFace("init");
    this.filterMessageCount();
  }

  selectTypeBloc(libelle){
    this.searchtypebloc = libelle;
    if(libelle == 'face'){
      this.isGeneral = false;
      this.isThematic = false;
    } else if(libelle == 'team'){
      this.isGeneral = true;
      this.isThematic = true;
    } else if(libelle == 'general'){
      this.isGeneral = true;
      this.isThematic = false;
    }
    this.selectChoiceFace("init");
    this.getSujet(this.projectId);
    this.typebloc = libelle;
    this.filterMessageCount();
  }

  selectStatusFace(libelle, item, type = null){
    this.statut = item;
    this.searchstatusface = libelle;
    this.isGeneral = false;
    this.isThematic = false;
    if(item == 'comment') {
      this.copy = null;
      this.statut = "comment";
      this.recipient = null;
      this.transmitter = null;

      this.initSenderFace('1');
      this.selectChoiceFace("init");
      this.filterMessageCount();
    } else if(item == 'false' && type == 'copy') {
      this.copy = this.currentUser.id;
      this.initSenderFace('1');
      this.selectChoiceFace("init");
      this.filterMessageCount();
    } else if(type == 'mine') {
      this.copy = null;
      this.selectSenderFace(this.currentUser.givenName, this.currentUser.familyName, this.currentUser.id);
    } else if(type == 'received') {
      this.copy = null;
      this.searchsenderface = "Éxpéditeur";
      this.transmitter = null; 
      this.getReceiver(null);
      this.selectRecipientFace(this.currentUser.givenName, this.currentUser.familyName, this.currentUser.id);
    } else if(type == 'true') {
      this.copy = null;
      this.selectSenderFace(this.currentUser.givenName, this.currentUser.familyName, this.currentUser.id);
    } else {
      this.copy = null;
      this.selectSenderFace(this.currentUser.givenName, this.currentUser.familyName, this.currentUser.id);
    }
  }
  
  selectThemeFace(libelle, id){
    this.searchthemeface = libelle;
    this.tag = id;
    this.filtersenderf = 'alpha';
    this.filterrecipientf = 'alpha';
    this.initSenderFace('1');
    this.initRecipientFace('1');
    this.selectChoiceFace("init");
    this.filterMessageCount();
    this.getContact();
    this.getReceiver(null);
  }

  onDateBeforChange(newDate: any): void {
    this.dateBefore = newDate;
    this.filterMessageCount();
  }

  onDateAfterChange(newDate: any): void {
    this.dateAfter = newDate;
    this.filterMessageCount();
  }

  onDeadlineBeforChange(newDate: any): void {
    this.dateDeadline = newDate;
    this.filterMessageCount();
  }

  onDeadlineAfterChange(newDate: any): void {
    this.dateDeadlineAfter = newDate;
    this.filterMessageCount();
  }

  resetSearchFace(){
    this.searchproject = "Dossier";
    this.searchtypemsgface = "Type d'échanges";
    this.searchtypeface = "Type de Document";
    this.searchtypebloc = "Type de bloc";
    this.searchsenderface = "Éxpéditeur";
    this.searchrecipientface = "Destinataire";
    this.searchcopyface = "Membre en Copie";
    this.searchthemeface = "Objet";
    this.searchtypeface = "Type de Document";
    this.searchdateface = "Face";
    this.searchstatusface = "Statut des faces";
    this.searchnumface = "Numéro du face";
  }

  getAvatarlUrl(avatarLink){
    return environment.server_url+avatarLink;
  }

  getProjectImage(avatarLink){
    return environment.server_url+"/media/project_img/"+avatarLink;
  }

  getContactImage(avatarLink){
    return environment.server_url+"/media/profil/"+avatarLink;
  }


  public refreshInfoFilter(){
    this.getContact();
    this.loadProject();  
  }

  goBack(){
    this.location.back();
    //this.router.navigate(['/project/'+this.recentProject]);
    //window.history.back();
  }




}


